import { render, staticRenderFns } from "./ZoneTerritoryCreate.vue?vue&type=template&id=2e997a58&"
import script from "./ZoneTerritoryCreate.vue?vue&type=script&lang=ts&"
export * from "./ZoneTerritoryCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports